<template>
  <v-container
    fluid
    grid-list-md
    v-if="selectedPlan !== null && selectedPlan !== undefined"
  >
    <v-layout row wrap>
      <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
        icon="folder_shared"
        :value="$t('views.members.member_record')"
        v-if="
          role.indexOf('Broker Plan Manager') > -1 ||
          role.indexOf('Broker Plan Admin') > -1 ||
          role.indexOf('Employer Plan Admin') > -1 ||
          role.indexOf('Employer Members Viewer') > -1
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              v-if="
                role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Employer Plan Admin') > -1
              "
              text
              color="primary"
              @click="
                $router.push({
                  name: 'addMemberWizard',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("globals.add_new") }}
            </v-btn>
            <v-btn
              v-if="
                role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Employer Plan Admin') > -1 ||
                role.indexOf('Employer Members Viewer') > -1
              "
              text
              color="primary"
              @click="
                $router.push({
                  name: 'searchMembersForm',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.members.find_and_edit") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
        icon="folder_shared"
        :value="$t('views.members.beneficiaries_record')"
        v-if="
          role.indexOf('Broker Plan Manager') > -1 ||
          role.indexOf('Broker Plan Admin') > -1 ||
          role.indexOf('Employer Beneficiaries Administrator') > -1
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              v-if="
                role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Employer Beneficiaries Administrator') > -1
              "
              text
              color="primary"
              @click="
                $router.push({
                  name: 'searchBeneficiariesForm',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.members.find_and_edit") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
        icon="reduce_capacity"
        :value="$t('views.members.members_list')"
        v-if="
          role.indexOf('Broker Plan Manager') > -1 ||
          role.indexOf('Broker Plan Admin') > -1 ||
          role.indexOf('Employer Plan Admin') > -1 ||
          role.indexOf('Employer Members Viewer') > -1
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'membersManagement',
                  params: { planId: selectedPlan.Id, edit: true },
                })
              "
            >
              {{ $t("components.claims_history.view_all") }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'membersImportSalaries',
                  params: { planId: selectedPlan.Id },
                })
              "
              v-if="
                role.indexOf('Broker Plan Manager') > -1 ||
                role.indexOf('Broker Plan Admin') > -1 ||
                role.indexOf('Employer Plan Admin') > -1
              "
            >
              {{ $t("views.members.bulk_update") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
        icon="schedule"
        :value="$t('views.members.member_hours')"
        v-if="
          planIdentity &&
          planIdentity.TrackHours &&
          (role.indexOf('Broker Plan Manager') > -1 ||
            role.indexOf('Employer Plan Admin') > -1)
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'pendingHoursTasksTable',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.members.tasks") }}
            </v-btn>
            <v-btn text color="primary" @click="bulkHoursClick">
              {{ $t("views.members.bulk_update") }}
            </v-btn>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
        icon="account_balance"
        :value="$t('components.plancreationwizard.eligibility_bank')"
        v-if="
          planIdentity &&
          planIdentity.HasEligibilityBank &&
          (role.indexOf('Broker Plan Manager') > -1 ||
            role.indexOf('Employer Plan Admin') > -1)
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-btn
              text
              color="primary"
              @click="
                $router.push({
                  name: 'eligibilityHourBankEvaluations',
                  params: { planId: selectedPlan.Id },
                })
              "
            >
              {{ $t("views.members.tasks") }}
            </v-btn>
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn slot="activator" color="primary" v-on="on" text>
                  {{ $t("views.members.select_wizard") }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  @click="
                    $router.push({
                      name: 'evaluateEligibilityHourBankWizard',
                      params: { planId: selectedPlan.Id },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("views.members.evaluation_wizard") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="
                    $router.push({
                      name: 'reevaluateEligibilityHourBankWizard',
                      params: { planId: selectedPlan.Id },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("views.members.reevaluation_wizard") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="
                    $router.push({
                      name: 'eligibilityBankCreditHours',
                      params: { planId: selectedPlan.Id },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("components.memberview.credit_hours") }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
        icon="payments"
        :value="$t('views.members.pending_self_payments')"
        v-if="
          planIdentity &&
          planIdentity.IncludeSelfPayments &&
          (role.indexOf('Broker Plan Manager') > -1 ||
            this.role.indexOf('Broker Plan Admin') > -1)
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn slot="activator" color="primary" v-on="on" text>
                  {{ $t("globals.select") }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  @click="
                    $router.push({
                      name: 'pendingSelfPayments',
                      params: { planId: selectedPlan.Id, deposited: 'all' },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("globals.all") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="
                    $router.push({
                      name: 'pendingSelfPayments',
                      params: {
                        planId: selectedPlan.Id,
                        deposited: 'deposited',
                      },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("headers.selfpayments.deposited") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="
                    $router.push({
                      name: 'pendingSelfPayments',
                      params: {
                        planId: selectedPlan.Id,
                        deposited: 'non-deposited',
                      },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("headers.selfpayments.non_deposited") }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </material-stats-card>
      <material-stats-card
        :color="$vuetify.theme.themes.light.secondary"
        icon="publish"
        :value="$t('views.members.data_import')"
        v-if="
          role.indexOf('Broker Plan Manager') > -1 ||
          role.indexOf('Broker Plan Admin') > -1
        "
      >
        <template slot="actions">
          <div class="d-flex justify-center flex-wrap">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn slot="activator" color="primary" v-on="on" text>
                  {{ $t("views.members.select_wizard") }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  @click="
                    $router.push({
                      name: 'membersImportWizard',
                      params: { planId: selectedPlan.Id },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("components.membersmanagementtable.members") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="selectedPlan.PlanType === 'HW'"
                  @click="
                    $router.push({
                      name: 'dependantsImportWizard',
                      params: { planId: selectedPlan.Id },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("globals.dependants") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="
                    $router.push({
                      name: 'contactInformationImportWizard',
                      params: { planId: selectedPlan.Id },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("components.memberview.contact_information") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  @click="
                    $router.push({
                      name: 'employmentInformationImportWizard',
                      params: { planId: selectedPlan.Id },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("components.memberview.employment_information") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="selectedPlan.PlanType === 'Pension'"
                  @click="
                    $router.push({
                      name: 'unionLocalMembershipImportWizard',
                      params: { planId: selectedPlan.Id },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("views.members.union_local_membership") }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="planIdentity.HasHSA"
                  @click="
                    $router.push({
                      name: 'hsaImportWizard',
                      params: { planId: selectedPlan.Id },
                    })
                  "
                >
                  <v-list-item-title>
                    {{ $t("components.memberview.hsa_credit") }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </material-stats-card>
    </v-layout>
    <v-dialog v-model="sickDayWarning" scrollable persistent max-width="400">
      <material-card
        :title="$t('globals.warning')"
        :color="$vuetify.theme.themes.light.warning"
        icon="science"
      >
        <v-card-text>
          {{ $t("views.members.sick_day_warning_message") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="sickDayWarning = false">
            {{ $t("globals.ok") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </v-container>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { planSetter } from "../mixins/planSetter";
export default {
  data() {
    return {
      commissionsCount: 3,
      sickDayWarning: false,
      noSickDaySettings: false,
    };
  },
  mixins: [planSetter],
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["messages"]),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("plansMembers", ["planOptions", "planIdentity"]),
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    ...mapActions("plansMembers", ["getPlanSickBankSettings"]),
    async loadSickBankSettings() {
      if (this.planIdentity.HasSickPaymentBank) {
        let sickDaySettings = (
          await this.getPlanSickBankSettings({
            planIdentityId: this.planIdentity.Id,
          })
        ).data;
        console.log(
          "sick day settings",
          sickDaySettings,
          sickDaySettings === null,
          sickDaySettings === undefined
        );
        if (
          sickDaySettings === null ||
          sickDaySettings === undefined ||
          sickDaySettings === ""
        ) {
          this.noSickDaySettings = true;
        }
      }
    },
    async bulkHoursClick() {
      await this.loadSickBankSettings();
      console.log("hour click: ", this.noSickDaySettings);
      if (this.noSickDaySettings === true) {
        this.sickDayWarning = true;
      } else {
        console.log("hour click: wtf", this.noSickDaySettings);
        this.$router.push({
          name: "hoursImportWizard",
          params: { planId: this.selectedPlan.Id },
        });
      }
    },
  },
};
</script>

<style>
.with-margin {
  margin: 10px !important;
}
</style>
